import { mogamboRequestV2 } from '@src/api/utils';
import { BASE_URL } from '@src/const';

export const createNewCodeNode = data => {
  const url = `${BASE_URL}node/processing/data/`;
  const headers = {
    'x-haptik-bot-name': data.domain_name,
  };
  const response = mogamboRequestV2(url, 'POST', data, false, headers);
  return Promise.resolve(response);
};

export const fetchCodeNodeData = nodeId => {
  const url = `${BASE_URL}node/processing/data/${nodeId}/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const saveCodeNodeData = (nodeId, data, domainTitle) => {
  const url = `${BASE_URL}node/processing/data/${nodeId}/`;
  const headers = {
    'x-haptik-bot-name': domainTitle,
  };
  const response = mogamboRequestV2(url, 'POST', data, false, headers);
  return Promise.resolve(response);
};

export const runCodeNodeData = (funcName, data) => {
  const url = `${BASE_URL}code_executor/run/${funcName}/`;
  const response = mogamboRequestV2(url, 'POST', data);
  return Promise.resolve(response);
};

export const fetchEnvVariables = domainId => {
  const url = `${BASE_URL}domain/env_variables/${domainId}/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const saveEnvVariables = (domainId, data) => {
  const url = `${BASE_URL}domain/env_variables/${domainId}/`;
  const response = mogamboRequestV2(url, 'POST', data);
  return Promise.resolve(response);
};
